import {useQuery} from '@tanstack/react-query'
import {QUERY_KEYS} from './keys'
import {getUnreadMessageCountRepresentative} from '../services/chat.http'

export const useGetUnreadMessageCountRepsV3 = () => {
    return useQuery({
        queryKey: [QUERY_KEYS.getUnreadMessageCountRepresentativeV3],
        queryFn: () => getUnreadMessageCountRepresentative()
    })
}
